import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Empty } from "@/components/ui-bits";
import { fmtINR, fmtDate } from "@/lib/format";
import { CreditCard } from "@phosphor-icons/react";
import { ReversePaymentButton } from "@/components/ReversePayment";

export default function Payments() {
  const { user } = useAuth();
  const canReverse = ["super_admin", "client_admin"].includes(user?.role);
  const isSuperAdmin = user?.role === "super_admin";
  const [items, setItems] = useState([]);
  const load = () => api.get("/payments").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const total = items.reduce((s, p) => s + (p.amount || 0), 0);

  return (
    <div data-testid="payments-page">
      <PageHeader title="Payments" subtitle="Tracking only — RecoverOS does not collect funds" />
      {isSuperAdmin && (
        <div className="border border-border bg-card p-4 mb-4 inline-flex items-center gap-3" data-testid="total-recorded-card">
          <CreditCard size={22} className="text-primary" />
          <div>
            <div className="label-caps">Total Recorded</div>
            <div className="text-2xl font-black font-heading mono text-emerald-600">{fmtINR(total)}</div>
          </div>
        </div>
      )}
      <div className="border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="label-caps border-b border-border bg-secondary/40">
              <th className="text-left p-3">Date</th>
              <th className="text-left p-3">Loan ID</th>
              <th className="text-left p-3">Borrower</th>
              <th className="text-right p-3">Amount</th>
              <th className="text-left p-3">Mode</th>
              <th className="text-left p-3">Reference</th>
              <th className="text-left p-3">Recorded By</th>
              {canReverse && <th className="text-center p-3 w-20">Actions</th>}
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-b border-border last:border-0 hover:bg-secondary/50">
                <td className="p-3 mono text-xs">{fmtDate(p.payment_date)}</td>
                <td className="p-3 mono text-primary">{p.loan_id}</td>
                <td className="p-3 font-medium">{p.borrower_name}</td>
                <td className="p-3 text-right mono font-semibold text-emerald-600">{fmtINR(p.amount)}</td>
                <td className="p-3">{p.mode}</td>
                <td className="p-3 mono text-xs">{p.reference}</td>
                <td className="p-3 text-muted-foreground">{p.recorded_by}</td>
                {canReverse && (
                  <td className="p-3 text-center">
                    <ReversePaymentButton payment={p} onReversed={load} />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && <Empty text="No payments recorded yet" />}
      </div>
    </div>
  );
}
